import { gpsService } from '../_services';
import { router } from '../_helpers';

const state = { onRequest: false, gpss: [], gps: {} };

const actions = {
    get({ dispatch, commit }, id) {
        commit('request');

        gpsService.get(id)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    add({ dispatch, commit }, data) {
        commit('request');

        gpsService.add(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/gps');
                    dispatch('alert/success', "GPS Added Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/gps');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    edit({ dispatch, commit }, data) {
        commit('request');

        gpsService.edit(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/gps');
                    dispatch('alert/success', "GPS Updated Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/gps');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    get_all({ dispatch, commit }) {
        commit('request');

        gpsService.get_all()
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    destroy({ dispatch, commit }, id){
      commit('request');

      gpsService.destroy(id)
          .then(
              async () => {
                  commit('success');
                  await router.go('/gps');
                  dispatch('alert/success', "GPS Deleted Successfully", { root: true });
              },
              async error => {
                  commit('error');
                  await router.go('/gps');
                  dispatch('alert/error', error, { root: true });
              }
          );
    },
    get_gps_by_account({ dispatch, commit }, data) {
        commit('request');

        gpsService.get_gps_by_account(data)
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  gpss: state => {
    return state.gpss
  },
  gps: state => {
    return state.gps
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.gps = {};
        state.gpss = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.gps = data;
    },
    success_datas(state, data) {
      state.onRequest = false;
      state.gpss = data;
    },
    error(state) {
        state.onRequest = false;
    },
};

export const gps = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
